import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-add-probe-config',
  templateUrl: './add-probe-config.component.html',
  styleUrls: ['./add-probe-config.component.scss']
})
export class AddProbeConfigComponent implements OnInit {

  addProbFormGroup : FormGroup;
  submitted:boolean;

  constructor(private formBuilder: FormBuilder,
    private endpointsService: EndpointsService,
    private backendApiService: BackendApiService,
    private spinnerService:Ng4LoadingSpinnerService) { }

  ngOnInit(): void {
    this.addprobe();
  }
addprobe(){
  this.addProbFormGroup = this.formBuilder.group({
    orgId:[],
    threadCount:[]
  })
}
onAdd(){
  // this.submitted=true;
  // if(this.addProbFormGroup.invalid){
  //   return;
  // }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_PROBE_CONFIG +
    '&orgId=' + this.addProbFormGroup.get('orgId').value+
    '&threadCount=' + this.addProbFormGroup.get('threadCount').value
    
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Added successfully');        
      //   this.spinnerService.show();
       
      // }
})
}

}
